import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3944";

export const getProfile = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const updateProfile = async (profileData: any) => {
  const token = localStorage.getItem("token");
  const response = await axios.put(`${API_URL}/users/update-profile`, profileData, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
